<template>
  <b-modal id="file-schedule-dialog" centered ref="modal" size="md" @hidden="onHidden" @show="onShow">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="txt-body txt-primary">Pick Schedule Date</h5>
      <b-button variant="icon" size="sm" @click="close()" class="close">
        <svg class="icon-sm" width="24" viewBox="0 0 24 24"><use xlink:href="#icon-cross"></use></svg>
      </b-button>
    </template>
    <hr class="mt-0 mb-3 negative-mx-4">
    <div class="fx-row-center gc-2" v-if="file">
      <div :key="`date-${dateKey}`" :class="{ 'w-100': !scheduleTime, 'w-60': scheduleTime }">
        <h5 class="txt-body mb-2">Release Date</h5>
        <div class="side-panel-group">
          <form-control-date with-caret hide-icon :small="false" v-model="scheduleDate" placeholder="Select Date" />
        </div>
      </div>
      <div :key="`time-${dateKey}`" class="w-40" v-if="scheduleTime">
        <h5 class="txt-body mb-2">Time</h5>
        <div class="side-panel-group">
          <form-control-date hide-icon :small="false" type="time" v-model="scheduleTime" placeholder="Select Time" :show-second="false" />
        </div>
      </div>
    </div>
    <span class="txt-body txt-muted">Your timezone is <b>{{ timezone.name }} (GMT{{ timezone.offset }})</b></span>
    <b-btn v-if="scheduleAt" @click="clearSchedule" block variant="warning" class="mt-3">
      <svg width="24" class="txt-red-3 mr-2" viewBox="0 0 24 24"><use xlink:href="#icon-trash"></use></svg>
      <span class="txt-red-3">Delete Schedule</span>
    </b-btn>
    <hr class="mt-3 mb-0 negative-mx-4">
    <template slot="modal-footer">
      <b-btn variant="secondary" block @click="$refs.modal.hide()">Cancel</b-btn>
      <b-btn :disabled="scheduling || unpublishing || !hasChanged" variant="primary" block @click="submit">
        {{ buttonLabel }}
      </b-btn>
    </template>
  </b-modal>
</template>

<script>
import LibraryBuilderTemplate from '@app2/modules/Library/Builder/Components/Template';
import get from 'lodash/get'
import eventBus from "@app2/core/eventBus";
import File from "@app2/models/File";
import FormControlDate from "@app2/core/Components/Common/Forms/Date";
import Hub from "@app2/models/Hub";
import rootRouter from "@app2/router";
import publishingMixin from "@app2/modules/Library/Builder/Pages/Media/publishing.mixin.js"

export default {
  name: 'Schedule',
  mixins: [publishingMixin],
  computed: {
    hub() {
      return Hub.find(get(rootRouter, 'currentRoute.params.hash'));
    },
    file() {
      return File.query().withAll().find(this.$store.state.v2.library.builder.fileToSchedule);
    },
    hasChanged() {
      return this.scheduleAt !== this.scheduleAtInitial;
    },
    buttonLabel() {
      if ( this.unpublishing ) return 'Clearing Schedule...';
      if ( this.scheduling ) return 'Scheduling...';
      if ( this.isScheduled && !this.scheduleAt ) return 'Confirm';
      if ( this.isScheduled && this.hasChanged ) return 'Save Changes';
      return 'Schedule Publish';
    }
  },
  components: {
    FormControlDate,
    LibraryBuilderTemplate,
  },
  methods: {
    setTime() {
      this.scheduleTime = `${this.$refs.hours.value}:${this.$refs.minutes.value}`;
    },
    onHidden() {
      this.$store.commit('v2/library/builder/SET_FILE_TO_SCHEDULE', null);
      this.scheduleAt = null;
      this.scheduleAtInitial = null;
      this.dateKey++;
    },
    onShow() {
      this.setScheduleAt();
    },
    async submit() {
      if ( this.isScheduled && !this.scheduleAt ) {
        await this.unpublish();
        this.$refs.modal.hide();
        return;
      }
      if (!this.hasChanged) return;
      await this.schedule();
      this.$refs.modal.hide();
    }
  },
}
</script>
